import React, { useEffect, useState } from "react";
import { Table, Container, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import moment from "moment";
import Select from "react-select";
import {
  getIssuesList,
  getTickets,
  updateTicket,
} from "../../../Service/AllTicketServiceAPI";

const NonSlaOpenTicketList = () => {
  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewImageBase64, setPreviewImageBase64] = useState(null);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [searchTicketNo, setSearchTicketNo] = useState("");
  const [issuesList, setIssuesList] = useState([]); // all issues from backend
  const [selectedIssueId, setSelectedIssueId] = useState(null); // currently selected issue


  const rowsPerPage = 4;

  useEffect(() => {
    fetchTickets();
    fetchIssuesList();
  }, []);




  const getRemarkOptions = (remarkList = []) => {
    if (!remarkList.length) {
      return [{ label: "No remarks", value: "no-remarks", fullText: "" }];
    }

    return remarkList
      .slice()
      .reverse()
      .map((r, index) => ({
        value: index,
        shortText:
          r.remark.length > 40
            ? r.remark.substring(0, 40) + "..."
            : r.remark,
        fullText: r.remark,
        time: moment(r.snapshotAt).format("DD MMM YYYY HH:mm"),
      }));
  };


  const RemarkOption = ({ data, innerRef, innerProps }) => (
    <div
      ref={innerRef}
      {...innerProps}
      title={`${data.fullText}\n${data.time}`}
      style={{
        padding: "8px",
        borderBottom: "1px solid #eee",
        cursor: "pointer",
        whiteSpace: "normal",
        fontSize: "13px",
      }}
    >
      <div style={{ fontWeight: 500 }}>{data.shortText}</div>
      <div style={{ fontSize: "11px", color: "#6c757d" }}>
        {data.time}
      </div>
    </div>
  );


  const fetchIssuesList = async () => {
    try {
      const res = await getIssuesList();

      const formatted = (res.data || [])
        .map((it) => ({
          id: Number(it.issueId),
          label: it.partName,
          priority: it.priority,
          otpType: it.jobType // OTP / NON_OTP from backend
        }))
        .sort((a, b) => a.label.localeCompare(b.label));

      setIssuesList(formatted);
    } catch (err) {
      console.error("Issue list fetch failed", err);
    }
  };


  const fetchTickets = async () => {
    try {
      const role = sessionStorage.getItem("role");
      const userId = sessionStorage.getItem("pkUserId");

      const response = await getTickets({
        ticketType: "SLA",
        status: "OPEN",
        userId,
        role,
      });

      const data = response.data;

      const sortedData = (data || []).sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      const editableData = sortedData.map((ticket) => ({
        ...ticket,
        isEditing: false,
        imageFile: null,
      }));

      setTickets(editableData);
    } catch (error) {
      console.error("Error fetching NON-SLA OPEN tickets:", error);
    }
  };


  const renderTableTooltip = (text, maxLength = 25) => {
    if (!text) return "-";

    return (
      <div className="table-tooltip">
        <span>
          {text.length > maxLength ? text.substring(0, maxLength) + "..." : text}
        </span>

        {text.length > maxLength && (
          <span className="table-tooltip-text">{text}</span>
        )}
      </div>
    );
  };




  const handleEditToggle = (ticketNumber) => {
    const updated = tickets.map((ticket) => {
      if (ticket.ticketNumber === ticketNumber) {
        // Prefill selectedIssueId for this ticket
        setSelectedIssueId(ticket.issueId || null);
        return { ...ticket, isEditing: !ticket.isEditing };
      }
      return ticket;
    });
    setTickets(updated);
  };


  const handleInputChange = (ticketNumber, field, value) => {
    const updated = tickets.map((ticket) =>
      ticket.ticketNumber === ticketNumber ? { ...ticket, [field]: value } : ticket
    );
    setTickets(updated);
  };

  const handleFileChange = (ticketNumber, file) => {
    if (!file) return;

    const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    const maxSize = 100 * 1024;

    if (!validTypes.includes(file.type)) {
      swal("Invalid Format", "Only JPG, JPEG, and PNG files are allowed.", "warning");
      return;
    }

    if (file.size > maxSize) {
      swal(
        "File Too Large",
        "Image must be less than 100 KB. Use an online compressor like https://image.pi7.org/reduce-image-size-in-kb.",
        "warning"
      );
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const updated = tickets.map((ticket) =>
        ticket.ticketNumber === ticketNumber
          ? { ...ticket, omcUploadedProofImage: reader.result, imageFile: file }
          : ticket
      );
      setTickets(updated);
      setPreviewImageBase64(reader.result);
      setShowPreviewModal(true);
    };
    reader.readAsDataURL(file);
  };


  const handleSave = async (ticket) => {
    try {
      const role = sessionStorage.getItem("role");
      const userId = sessionStorage.getItem("pkUserId");

      // Send full issue object in payload
      const payload = {
        ...ticket,
        issueIds: ticket.issues?.map(i => i.issueId) || [],
      };

      const response = await updateTicket(
        ticket.ticketNumber,
        payload,
        { role, userId }
      );

      const result = response.data;

      if (result.message === "Ticket updated successfully") {
        const updated = tickets.map((t) =>
          t.ticketNumber === ticket.ticketNumber
            ? { ...t, isEditing: false, imageFile: null }
            : t
        );
        setTickets(updated);
        swal("Success", result.message, "success");
      } else {
        swal("Error", result.message || "Could not update ticket", "error");
      }
    } catch (error) {
      console.error("Failed to update ticket:", error);
      const errMsg = error.response?.data?.message || "Could not update ticket";
      swal("Error", errMsg, "error");
    }
  };

  const issueOptions = issuesList.map((i) => ({
    value: i.id,
    label: `${i.label} (${i.priority})`,
    priority: i.priority,
    otpType: i.otpType,
  }));


  const filteredTickets = tickets.filter((ticket) =>
    ticket.ticketNumber
      ?.toString()
      .toLowerCase()
      .includes(searchTicketNo.toLowerCase())
  );

  // Pagination after filter
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentTickets = filteredTickets.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredTickets.length / rowsPerPage);




  const getFormLink = (jobType) => {
    if (!jobType || jobType.toLowerCase() === "unassigned") return null;

    switch (jobType.toLowerCase()) {
      case "installation":
        return "/work-order/installation";
      case "calibration":
        return "/work-order/calibration";
      case "field job":
        return "/work-order/field-job";
      default:
        return null;
    }
  };

  const getPriorityStyle = (priority) => {
    let backgroundColor = "gray";
    if (priority === "HIGH") backgroundColor = "red";
    else if (priority === "MEDIUM") backgroundColor = "orange";
    else if (priority === "LOW") backgroundColor = "green";

    return {
      fontWeight: "bold",
      color: "white",
      backgroundColor,
      textAlign: "center",
    };
  };



  return (
    <Container className="mt-4">
      <Form.Control
        type="text"
        placeholder="Search by Ticket Number"
        value={searchTicketNo}
        onChange={(e) => {
          setSearchTicketNo(e.target.value);
          setCurrentPage(1);
        }}
        style={{ maxWidth: "250px", }}
      />
      <div className="d-flex justify-content-end mb-2">

      </div>

      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover responsive style={{ backgroundColor: "white" }}>
          <thead className="header-class">
            <tr>
              <th>Ticket No.</th>
              <th>Ticket Type</th>
              <th>Ticket Status</th>
              <th>Ticket Priority</th>
              <th>Action</th>
              <th>Issue Reported</th>
              <th>Remark by Nontech person</th>
              <th>Remark by tech person</th>
              <th>WO Status</th>
              <th>Dispenser Sr No</th>
              <th>OMC Approval</th>
              <th>WO approval OMC Proof</th>
              <th>RO Name</th>
              <th>Ro Contact</th>
              <th>Ro State</th>
              <th>RO City</th>
              <th>Ro District</th>
              <th>Ro Address</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {currentTickets.map((ticket) => {
              console.log("TICKET ROW:", ticket);
              const isEditing = ticket.isEditing;
              const formLink = getFormLink(ticket.jobType);

              return (
                <tr key={ticket.ticketNumber}>
                  <td>{ticket.ticketNumber}</td>


                  {isEditing ? (
                    <>

                      <td>
                        {ticket.ticketType}
                      </td>


                      <td>
                        <Form.Select
                          value={ticket.status}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "status", e.target.value)
                          }
                        >
                          <option value="OPEN">OPEN</option>
                          <option value="IN_PROGRESS">IN_PROGRESS</option>
                          <option value="CLOSE">CLOSE</option>
                        </Form.Select>
                      </td>

                      {/* <td>
                        <Form.Control
                          value={ticket.priority || ""}
                          onChange={(e) => handleInputChange(ticket.ticketNumber, "priority", e.target.value)}
                        />
                      </td> */}
                      <td>
                        <Form.Select
                          value={ticket.priority || ""}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "priority", e.target.value)
                          }
                        >
                          <option value="HIGH">HIGH</option>
                          <option value="MEDIUM">MEDIUM</option>
                          <option value="LOW">LOW</option>
                        </Form.Select>
                      </td>
                      <td>
                        <Button size="sm" variant="success" onClick={() => handleSave(ticket)}>
                          Save
                        </Button>{" "}
                        <Button size="sm" variant="secondary" onClick={() => handleEditToggle(ticket.ticketNumber)}>
                          Cancel
                        </Button>
                      </td>

{/* commented bcz user should not update issue */}
                      {/* <td style={{ minWidth: "220px" }}>
                        <Select
                          name="issueReported"
                          placeholder="Select Issue"
                          options={issueOptions}
                          value={
                            issueOptions.find(
                              (opt) => opt.value === ticket.issues?.[0]?.issueId
                            ) || null
                          }

                          onChange={(selected) => {
                            if (!selected) return;

                            const idNum = Number(selected.value);

                            setTickets((prev) =>
                              prev.map((t) =>
                                t.ticketNumber === ticket.ticketNumber
                                  ? {
                                    ...t,


                                    issues: [
                                      {
                                        issueId: idNum,
                                        partName: selected.label.split(" (")[0],
                                        priority: selected.priority,
                                        otpType: selected.otpType || "NON_OTP",
                                      },
                                    ],

                                    issueReported: selected.label.split(" (")[0],


                                    jobType:
                                      idNum === 4
                                        ? "Installation"
                                        : idNum === 3
                                          ? "Calibration"
                                          : "Field Job",
                                  }
                                  : t
                              )
                            );
                          }}

                          isClearable={false}
                        />
                      </td> */}

                      <td>
                        {ticket.issueReported}
                      </td>



                      <td>
                        {(role === "nontech person" || role === "admin") && (
                          <Form.Control
                            placeholder="Enter non-tech remark"
                            value={ticket.remarkByNonTech || ""}
                            onChange={(e) =>
                              handleInputChange(
                                ticket.ticketNumber,
                                "remarkByNonTech",
                                e.target.value
                              )
                            }
                          />
                        )}
                      </td>


                      <td>
                        {(role === "tech person" || role === "admin") && (
                          <Form.Control
                            placeholder="Enter tech remark"
                            value={ticket.remarkByTech || ""}
                            onChange={(e) =>
                              handleInputChange(
                                ticket.ticketNumber,
                                "remarkByTech",
                                e.target.value
                              )
                            }
                          />
                        )}
                      </td>


                      <td>
                        {ticket.woStatus}
                      </td>
                      <td>
                        {ticket.dispenserSrNo}
                      </td>


                      <td>
                        <Form.Select
                          value={ticket.omcApprovalStatus || ""}
                          onChange={(e) =>
                            handleInputChange(ticket.ticketNumber, "omcApprovalStatus", e.target.value)
                          }
                        >
                          <option value="PENDING">PENDING</option>
                          <option value="APPROVED">APPROVED</option>
                          <option value="NOT_REQUIRED ">NOT_REQUIRED  </option>
                        </Form.Select>
                      </td>
                      <td>
                        <Form.Control
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          onChange={(e) => handleFileChange(ticket.ticketNumber, e.target.files[0])}
                        />
                      </td>


                      <td>
                        {ticket.roName}
                      </td>

                      <td>
                        {ticket.roContact}
                      </td>

                      <td>
                        {ticket.roState}
                      </td>
                      <td>
                        {ticket.roCity}
                      </td>

                      <td>
                        {ticket.roDistrict}
                      </td>
                      <td>
                        {ticket.roAddress}
                      </td>
                      <td>{moment(ticket.createdAt).format("DD MMM YYYY, h:mm A")}</td>



                    </>
                  ) : (
                    <>


                      <td>{ticket.ticketType}</td>

                      <td>
                        <span
                          style={{
                            padding: "5px 10px",
                            borderRadius: "5px",
                            color: "white",
                            backgroundColor:
                              ticket.status === "OPEN"
                                ? "red"
                                : ticket.status === "IN_PROGRESS"
                                  ? "orange"
                                  : "green",
                            fontWeight: "bold",
                          }}
                        >
                          {ticket.status}
                        </span>
                      </td>



                      <td style={getPriorityStyle(ticket.priority)}>{ticket.priority || "N/A"}</td>
                      <td>
                        <Button size="sm" variant="primary" onClick={() => handleEditToggle(ticket.ticketNumber)}>
                          Update
                        </Button>
                      </td>
                      <td>{ticket.issueReported}</td>


                      <td style={{ minWidth: "220px" }}>

                        <Select
                          options={getRemarkOptions(ticket.nonTechRemarkDto)}
                          components={{ Option: RemarkOption, IndicatorSeparator: () => null }}
                          isSearchable={false}
                          isClearable={false}
                          menuPlacement="auto"
                          maxMenuHeight={220}
                          placeholder="View remarks"
                          value={null}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: "32px",
                              backgroundColor: "#f8f9fa",
                              cursor: "pointer",
                            }),
                            singleValue: () => ({
                              display: "none",
                            }),
                          }}
                        />

                      </td>


                      <td style={{ minWidth: "220px" }}>

                        <Select
                          options={getRemarkOptions(ticket.techRemarkDto)}
                          components={{ Option: RemarkOption, IndicatorSeparator: () => null }}
                          isSearchable={false}
                          isClearable={false}
                          menuPlacement="auto"
                          maxMenuHeight={220}
                          placeholder="View remarks"
                          value={null}
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: "32px",
                              backgroundColor: "#f8f9fa",
                              cursor: "pointer",
                            }),
                            singleValue: () => ({
                              display: "none",
                            }),
                          }}
                        />

                      </td>


                      <td>{ticket.woStatus}</td>
                      <td>{ticket.dispenserSrNo}</td>
                      <td>{ticket.omcApprovalStatus}</td>
                      <td>
                        {ticket.omcUploadedProofImage ? (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              setPreviewImageBase64(ticket.omcUploadedProofImage);
                              setShowPreviewModal(true);
                            }}
                          >
                            View Image
                          </Button>
                        ) : (
                          " Image not uploaded"
                        )}
                      </td>
                      <td>{ticket.roName}</td>
                      <td>{ticket.roContact}</td>
                      <td>{ticket.roState}</td>
                      <td>{ticket.roCity}</td>
                      <td>{ticket.roDistrict}</td>

                      <td>{renderTableTooltip(ticket.roAddress)}</td>
                      <td>{moment(ticket.createdAt).format("DD MMM YYYY, h:mm A")}</td>


                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>

        {filteredTickets.length > rowsPerPage && (
          <div className="d-flex justify-content-center align-items-center my-3">
            <Button size="sm" variant="secondary" disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)}>
              Prev
            </Button>
            <span className="mx-3">
              Page {currentPage} of {totalPages}
            </span>
            <Button size="sm" variant="secondary" disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)}>
              Next
            </Button>
          </div>
        )}
      </div>

      <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Uploaded Image </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImageBase64 ? (
            <img src={previewImageBase64} alt="Preview" style={{ maxWidth: "60%", height: "50%" }} />
          ) : (
            <p>No Image to display</p>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default NonSlaOpenTicketList;














